export default {
  toggleElement: null,
  parentElement: null,
  navElement: null,
  firstFocusableElement: null,
  lastFocusableElement: null,

  handleNavigationToggle(e) {
    e.preventDefault();
    this.parentElement.classList.toggle('nav--open');
    
    const isExpanded = this.parentElement.classList.contains('nav--open');
    this.toggleElement.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    this.announceChange(isExpanded ? 'Navigation menu opened' : 'Navigation menu closed');
    
    if (isExpanded) {
      this.setupFocusTrap();
      document.addEventListener('keydown', this.handleKeyEvents.bind(this));
    } else {
      document.removeEventListener('keydown', this.handleKeyEvents.bind(this));
      this.toggleElement.focus();
    }
  },

  handleKeyEvents(e) {
    if (e.key === 'Escape') {
      this.toggleElement.click();
    } else if (e.key === 'Tab') {
      if (document.activeElement === this.lastFocusableElement && !e.shiftKey) {
        e.preventDefault();
        this.firstFocusableElement.focus();
      } else if (document.activeElement === this.firstFocusableElement && e.shiftKey) {
        e.preventDefault();
        this.lastFocusableElement.focus();
      }
    }
  },

  setupFocusTrap() {
    const focusableElements = this.navElement.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    this.firstFocusableElement = focusableElements[0];
    this.lastFocusableElement = focusableElements[focusableElements.length - 1];
    
    if (this.firstFocusableElement) {
      this.firstFocusableElement.focus();
    }
  },

  setupSubmenuAccessibility() {
    const itemsWithSubmenu = document.querySelectorAll('.site-masthead-menu-item:has(.site-masthead-submenu)');
    
    itemsWithSubmenu.forEach(item => {
      const link = item.querySelector('.site-masthead-menu-link');
      const submenu = item.querySelector('.site-masthead-submenu');
      
      if (!link || !submenu) return;
      
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('aria-hidden', 'true');
      
      const submenuLinks = submenu.querySelectorAll('.site-masthead-submenu-link');
      submenuLinks.forEach(sublink => {
        sublink.setAttribute('tabindex', '-1');
      });
      
      const openSubmenu = () => {
        item.classList.add('open');
        link.setAttribute('aria-expanded', 'true');
        submenu.setAttribute('aria-hidden', 'false');
        submenuLinks.forEach(sublink => sublink.setAttribute('tabindex', '0'));
        this.announceChange(`${link.textContent.trim()} submenu opened.`);
      };
      
      const closeSubmenu = () => {
        item.classList.remove('open');
        link.setAttribute('aria-expanded', 'false');
        submenu.setAttribute('aria-hidden', 'true');
        submenuLinks.forEach(sublink => sublink.setAttribute('tabindex', '-1'));
      };
      
      item.addEventListener('mouseenter', openSubmenu);
      item.addEventListener('mouseleave', closeSubmenu);
      link.addEventListener('focus', openSubmenu);
      
      item.addEventListener('focusout', () => setTimeout(() => {
        if (!item.contains(document.activeElement)) closeSubmenu();
      }, 10));
      
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && link.getAttribute('aria-expanded') === 'true') {
          closeSubmenu();
          link.focus();
          e.preventDefault();
        }
      });
    });
  },

  getOrCreateAnnouncer() {
    let announcer = document.getElementById('nav-announcer');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'nav-announcer';
      announcer.setAttribute('aria-live', 'polite');
      announcer.classList.add('sr-only');
      document.body.appendChild(announcer);
    }
    return announcer;
  },

  announceChange(message) {
    const announcer = this.getOrCreateAnnouncer();
    announcer.textContent = '';
    setTimeout(() => {
      announcer.textContent = message;
    }, 50);
  },

  init() {
    this.toggleElement = document.getElementById('navigation-toggle');
    this.parentElement = document.getElementById('masthead');
    this.navElement = document.getElementById('navigation');
    
    if (this.toggleElement) {
      this.toggleElement.setAttribute('aria-expanded', 'false');
      this.toggleElement.addEventListener('click', this.handleNavigationToggle.bind(this));
    }
    
    this.setupSubmenuAccessibility();
  }
};
